import { FoodsThemeOptionsProvider, Themes, isTheme, themes } from "@foodpilot/foods";
import { createTheme, ThemeProvider } from "@mui/material";
import { useApplicationParameters } from "./api/client-api/appParams";
import { getThemeOverride } from "./themeOverride";

type ThemedAppProps = {
    children: JSX.Element;
};
export const ThemedApp = (props: ThemedAppProps) => {
    const { applicationParameters, isFeatureActivated } = useApplicationParameters();
    const themeParameter = applicationParameters?.theme ?? "";
    const theme: Themes = isTheme(themeParameter) ? themeParameter : "foodpilot";

    const isDesignOverriden = isFeatureActivated("dx-ux-testing");
    const themeOverride = getThemeOverride({ isOverriden: isDesignOverriden });

    // FoodsThemeProvider is essential to be able to use the Foods component
    // with the correct theme.
    // The ThemeProvider is essential because if we directly use MUI component
    // inside this app, we want them to also have the Theme.

    // One solution would be to export the MUI component from Foods, and not
    // install MUI at all in foodpilot-app.

    const localTheme = createTheme(themes[theme], themeOverride);
    return (
        <FoodsThemeOptionsProvider theme={theme} themeOverride={themeOverride}>
            <ThemeProvider theme={localTheme}>{props.children}</ThemeProvider>
        </FoodsThemeOptionsProvider>
    );
};
